(function ($) {
  Drupal.behaviors.giftNavFormatterV1 = {
    attach: function (context) {
      var $giftNav = $('.js-gift-nav', context);
      var $navLink = $('.js-gift-nav-item', context);

      $giftNav.first().addClass('active');
      $navLink.each(function (index, item) {
        var navId = $(item).data('nav-id');

        $('.js-split-width-content-block', context).eq(index).attr('id', navId);
      });
      $giftNav.once().on('click', function () {
        $giftNav.removeClass('active');
        $(this).addClass('active');
      });
    }
  };
})(jQuery);
